module.exports = __webpack_public_path__ + "img/blg-logo.eb3db243.jpg";